<div class="row">
    <div class="col-sm-12">
        <kendo-stepper [steps]="customerStatusList"
                       [(currentStep)]="currentStep"
                       stepType="full"
                       orientation="horizontal"
                       [linear]="false"
                       (activate)="activate($event)"
                       (currentStepChange)="currentStepChange($event)">
            <ng-template kendoStepperLabelTemplate let-step>
                <span>{{ step.abbreviation }}</span>
            </ng-template>
        </kendo-stepper>
    </div>
</div>
<div class="row">
    <div class="col-sm-12">
        <div class="row" *ngFor="let checklist of customerStatusChecklists;let idx = index;">
            <div class="col-sm-12" *ngIf="allChecklistMaps.length > 0 && checklist.customerStatusId == currentStatus.customerStatusId">
                <input type="checkbox"
                       id="{{checklist.stage}}Checkbox"
                       name="{{checklist.stage}}Checkbox"
                       style="transform: scale(1.5); margin: 5px;"
                       (change)="saveChecklistMap(checklist, 'completed', $event)"
                       [(ngModel)]="allChecklistMaps[idx].completed"
                       [checked]="isChecklistMapCompleted(checklist)"
                       [disabled]="isChecklistMapDisabled(checklist)"
                       required />
                <label for="{{checklist.stage}}Checkbox">{{checklist.description}}</label>
                <span>{{getCompletedChecklistTimestamp(checklist)}}</span>
                <textarea id="{{checklist.stage}}Text"
                          name="{{checklist.stage}}Text"
                          class="form-control" rows="3" cols="50"
                          style="max-width:500px;"
                          placeholder="Enter Notes..."
                          [(ngModel)]="allChecklistMaps[idx].notes"
                          (focusout)="saveChecklistMap(checklist, 'notes', $event)"
                          [disabled]="isChecklistMapDisabled(checklist)">{{ allChecklistMaps[idx].notes }}</textarea>
            </div>
        </div>
    </div>
</div>
